/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Asse semantico dell\'attributo dichiarato dal bando 
 */
export enum BindingTarget {

    SYSTEM_PRATICA_CODICE_ANPR = 'SYSTEM_PRATICA_CODICE_ANPR',

    SYSTEM_PRATICA_DICHIARAZIONE_PRIVACY = 'SYSTEM_PRATICA_DICHIARAZIONE_PRIVACY',

    SYSTEM_PRATICA_CANALE_RICEZIONE_OTP = 'SYSTEM_PRATICA_CANALE_RICEZIONE_OTP',

    SYSTEM_ANAGRAFICA_NOME = 'SYSTEM_ANAGRAFICA_NOME',

    SYSTEM_ANAGRAFICA_COGNOME = 'SYSTEM_ANAGRAFICA_COGNOME',

    SYSTEM_ANAGRAFICA_EMAIL = 'SYSTEM_ANAGRAFICA_EMAIL',

    SYSTEM_ANAGRAFICA_CODICE_FISCALE = 'SYSTEM_ANAGRAFICA_CODICE_FISCALE',

    SYSTEM_ANAGRAFICA_DATA_NASCITA = 'SYSTEM_ANAGRAFICA_DATA_NASCITA',

    SYSTEM_ANAGRAFICA_PROVINCIA_NASCITA = 'SYSTEM_ANAGRAFICA_PROVINCIA_NASCITA',

    SYSTEM_ANAGRAFICA_COMUNE_NASCITA = 'SYSTEM_ANAGRAFICA_COMUNE_NASCITA',

    SYSTEM_ANAGRAFICA_NAZIONE_NASCITA = 'SYSTEM_ANAGRAFICA_NAZIONE_NASCITA',

    SYSTEM_ANAGRAFICA_CITTADINANZA = 'SYSTEM_ANAGRAFICA_CITTADINANZA',

    SYSTEM_ANAGRAFICA_INDIRIZZO_RESIDENZA = 'SYSTEM_ANAGRAFICA_INDIRIZZO_RESIDENZA',

    SYSTEM_ANAGRAFICA_COMUNE_RESIDENZA = 'SYSTEM_ANAGRAFICA_COMUNE_RESIDENZA',

    SYSTEM_ANAGRAFICA_RESIDENTE_FUORI_COMUNE = 'SYSTEM_ANAGRAFICA_RESIDENTE_FUORI_COMUNE',

    SYSTEM_ANAGRAFICA_PROVINCIA_RESIDENZA = 'SYSTEM_ANAGRAFICA_PROVINCIA_RESIDENZA',

    SYSTEM_ANAGRAFICA_CAP_RESIDENZA = 'SYSTEM_ANAGRAFICA_CAP_RESIDENZA',

    SYSTEM_ANAGRAFICA_TIPO_DOCUMENTO = 'SYSTEM_ANAGRAFICA_TIPO_DOCUMENTO',

    SYSTEM_ANAGRAFICA_NUMERO_DOCUMENTO = 'SYSTEM_ANAGRAFICA_NUMERO_DOCUMENTO',

    SYSTEM_ANAGRAFICA_SCADENZA_DOCUMENTO = 'SYSTEM_ANAGRAFICA_SCADENZA_DOCUMENTO',

    SYSTEM_ANAGRAFICA_TELEFONO_FISSO = 'SYSTEM_ANAGRAFICA_TELEFONO_FISSO',

    SYSTEM_ANAGRAFICA_CELLULARE = 'SYSTEM_ANAGRAFICA_CELLULARE',

    SYSTEM_ANAGRAFICA_ISEE = 'SYSTEM_ANAGRAFICA_ISEE',

    SYSTEM_NUCLEO_NOME = 'SYSTEM_NUCLEO_NOME',

    SYSTEM_NUCLEO_COGNOME = 'SYSTEM_NUCLEO_COGNOME',

    SYSTEM_NUCLEO_CODICE_FISCALE = 'SYSTEM_NUCLEO_CODICE_FISCALE',

    SYSTEM_NUCLEO_DATA_NASCITA = 'SYSTEM_NUCLEO_DATA_NASCITA',

    SYSTEM_NUCLEO_PROVINCIA_NASCITA = 'SYSTEM_NUCLEO_PROVINCIA_NASCITA',

    SYSTEM_NUCLEO_COMUNE_NASCITA = 'SYSTEM_NUCLEO_COMUNE_NASCITA',

    SYSTEM_NUCLEO_NAZIONE_NASCITA = 'SYSTEM_NUCLEO_NAZIONE_NASCITA',

    SYSTEM_NUCLEO_CITTADINANZA = 'SYSTEM_NUCLEO_CITTADINANZA',

    SYSTEM_NUCLEO_PARENTELA = 'SYSTEM_NUCLEO_PARENTELA',

    SYSTEM_NUCLEO_NON_AUTOSUFFICIENTE = 'SYSTEM_NUCLEO_NON_AUTOSUFFICIENTE',

    SYSTEM_NUCLEO_PERCEPISCE_REDDITO = 'SYSTEM_NUCLEO_PERCEPISCE_REDDITO',

    SYSTEM_NUCLEO_IMPORTO_REDDITO = 'SYSTEM_NUCLEO_IMPORTO_REDDITO',

    SYSTEM_NUCLEO_SCUOLA_ISTITUTO = 'SYSTEM_NUCLEO_SCUOLA_ISTITUTO',

    SYSTEM_NUCLEO_SCUOLA_INDIRIZZO = 'SYSTEM_NUCLEO_SCUOLA_INDIRIZZO',

    SYSTEM_NUCLEO_SCUOLA_CLASSE = 'SYSTEM_NUCLEO_SCUOLA_CLASSE',

    SYSTEM_NUCLEO_SCUOLA_SEZIONE = 'SYSTEM_NUCLEO_SCUOLA_SEZIONE',

    FILE_DOCUMENTO = 'FILE_DOCUMENTO',

    FILE_ALLEGATO = 'FILE_ALLEGATO',

    CUSTOM_STRING = 'CUSTOM_STRING',

    CUSTOM_NUMBER = 'CUSTOM_NUMBER',

    CUSTOM_DATE = 'CUSTOM_DATE',

    CUSTOM_BOOLEAN = 'CUSTOM_BOOLEAN',

    CUSTOM_SINGLE_CHOICE = 'CUSTOM_SINGLE_CHOICE',

    CUSTOM_MULTIPLE_CHOICE = 'CUSTOM_MULTIPLE_CHOICE'
}

